import { ResponseLesson } from 'types/lesson';

export const sortLessons = <Lesson extends Pick<ResponseLesson, 'order'>>(lessons: Lesson[]): Lesson[] =>
    lessons.sort((firstLesson, nextLesson) => firstLesson.order - nextLesson.order);
